import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from '@material-ui/core';
import { BackdropCircular } from 'components';
import { getNextechDuplicatedCustomersApi } from '../../api';
import { useStyles } from './styles';
import NextechDuplicatedCustomerRow from './NextechDuplicatedCustomerRow';


const NextechDuplicatedCustomersList = ({ orderId, nextechCustomerId, setNextechCustomerId }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    nextechDuplicatedCustomersList,
    loadingNextechDuplicatedCustomers
  } = useSelector((state) => state.store_orders);

  useEffect(() => {
    getNextechDuplicatedCustomersApi({ dispatch, orderId });
  }, []);


  return (
    <div>
      <TableContainer>
        <Table aria-label="table" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>
                Choose Account
              </TableCell>
              <TableCell>
                Nextech UI ID
              </TableCell>
              <TableCell>
                Name
              </TableCell>
              <TableCell>
                Last Name
              </TableCell>
              <TableCell>
                Email
              </TableCell>
              <TableCell>
                Phone
              </TableCell>
              <TableCell>
                Date of Birth
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!nextechDuplicatedCustomersList.length ?
              <TableRow>
                <TableCell colSpan={10} align="center">
                  No matching customers found.
                </TableCell>
              </TableRow>
              :
              <>
                {nextechDuplicatedCustomersList.map((duplicatedCustomer) => {
                  return (
                    <NextechDuplicatedCustomerRow
                      key={duplicatedCustomer.ui_id}
                      duplicatedCustomer={duplicatedCustomer}
                      setNextechCustomerId={setNextechCustomerId}
                      nextechCustomerId={nextechCustomerId}
                    />
                  );
                })
                }
              </>
            }
          </TableBody>
        </Table>
      </TableContainer>
      <BackdropCircular loading={loadingNextechDuplicatedCustomers} />
    </div>
  );
};

export default NextechDuplicatedCustomersList;
